<template>
  <div>
    <div class="head">
      <div class="return_button" @click="goBack">返回列表页</div>
      <div class="hight_title">
        <div class="cn_title">搜索详情</div>
        <div class="en_title">SEARCH DETAILS</div>
      </div>
    </div>
    <!-- body -->
    <div class="body">
      <!-- 新闻咨询 -->
      <div v-if="newsList.count">
        <div class="content_row">
          <div class="colum"></div>
          <span class="content_title">新闻咨询({{newsList.count}})</span>
        </div>
        <div
          class="content"
          v-for="item in newsList.list"
          :key="item.id"
          @click="toNews(item.id)"
        >
          <div class="img_box">
            <img :src="img_api + item.image" alt="" />
          </div>
          <div class="right_content">
            <div class="title">{{ item.name }}</div>
            <div class="des">{{ item.brief }}</div>
          </div>
        </div>
        <div>
          <button class="more" @click="moreNews" v-show="newsList.count>newsNum">查看更多</button>
        </div>
      </div>
      <!-- 贸易板块 -->
      <div style="margin-bottom: 2rem" v-if="tradeList.count">
        <div class="content_row">
          <div class="colum"></div>
          <span class="content_title">贸易板块({{tradeList.count}})</span>
        </div>
        <div
          class="content"
          v-for="item in tradeList.list"
          :key="item.id"
          @click="toTrade(item.id)"
        >
          <div class="img_box">
            <img :src="img_api + item.images[0]" alt="" />
          </div>
          <div class="right_content">
            <div class="title">{{ item.name }}</div>
            <div class="des">{{ item.brief }}</div>
          </div>
        </div>
        <div>
          <button class="more" @click="moreTrade" v-show="tradeList.count>tradeNum">查看更多</button>
        </div>
      </div>
      <!-- 施工租赁 -->
      <div style="margin-bottom: 2rem" v-if="buildList.count">
        <div class="content_row">
          <div class="colum"></div>
          <span class="content_title">施工租赁板块({{buildList.count}})</span>
        </div>
        <div
          class="content"
          v-for="item in buildList.list"
          :key="item.id"
          @click="toBuild(item.id)"
        >
          <div class="img_box">
            <img :src="img_api + item.image" alt="" />
          </div>
          <div class="right_content">
            <div class="title">{{ item.name }}</div>
            <div class="des">{{ item.brief }}</div>
          </div>
        </div>
        <div>
          <button class="more" @click="moreBuild" v-show="buildList.count>buildNum">查看更多</button>
        </div>
      </div>
      <!-- 沥拌站 -->
      <div style="margin-bottom: 2rem" v-if="operationList.count">
        <div class="content_row">
          <div class="colum"></div>
          <span class="content_title">沥拌站运维板块({{operationList.count}})</span>
        </div>
        <div
          class="content"
          v-for="item in operationList.list"
          :key="item.id"
          @click="toOperation(item.id)"
        >
          <div class="img_box">
            <img :src="img_api + item.image" alt="" />
          </div>
          <div class="right_content">
            <div class="title">{{ item.name }}</div>
            <div class="des">{{ item.brief }}</div>
          </div>
        </div>
        <div>
          <button class="more" @click="moreOperation" v-show="operationList.count>operationNum">查看更多</button>
        </div>
      </div>
      <!-- 工程案例板块 -->
      <div style="margin-bottom: 2rem" v-if="projectCaseList.count">
        <div class="content_row">
          <div class="colum"></div>
          <span class="content_title">工程案例({{projectCaseList.count}})</span>
        </div>
        <div
          class="content"
          v-for="item in projectCaseList.list"
          :key="item.id"
          @click="toProject(item.id)"
        >
          <div class="img_box">
            <img :src="img_api + item.image" alt="" />
          </div>
          <div class="right_content">
            <div class="title">{{ item.name }}</div>
            <div class="des">{{ item.brief }}</div>
          </div>
        </div>
            <div>
        <button class="more" @click="moreProject" v-show="projectCaseList.count>projectNum">查看更多</button>
      </div></div>

    </div>
  </div>
</template>

<script>
import { control } from "@/server/https.js";
export default {
  name: "",
  data() {
    return {
      newsList: [],
      projectCaseList: [],
      operationList: [],
      tradeList: [],
      buildList: [],
      img_api: 'https://www.gdyuanwo.com/gdyuanwo/',
      newsNum:3,
      tradeNum:3,
      operationNum:3,
      buildNum:3,
      projectNum:3
    };
  },
  mounted() {
    this.getNews();
    this.getTrades();
    this.getOperation();
    this.getOperation();
    this.getBuild();
    this.getProject();

  },
  methods: {
    getNews(){
      control({
      type: 1,
      searchName: this.$route.query.keywords,
      pageNo: 1,
      pageSize: this.newsNum,
    }).then((res) => {
      this.newsList = res.data.body.data;
    });
    },
    //贸易
    getTrades(){
      control({
      type: 2,
      searchName: this.$route.query.keywords,
      pageNo: 1,
      pageSize: this.tradeNum,
    }).then((res) => {
      this.tradeList = res.data.body.data;
    });
    },
    //沥拌
    getOperation(){
      control({
      type: 3,
      searchName: this.$route.query.keywords,
      pageNo: 1,
      pageSize: this.operationNum,
    }).then((res) => {
      this.operationList = res.data.body.data;
    });
    },
    //施工
    getBuild(){
      control({
      type: 4,
      searchName: this.$route.query.keywords,
      pageNo: 1,
      pageSize: this.buildNum,
    }).then((res) => {
      this.buildList = res.data.body.data;
    });
    },
    //工程
    getProject(){
      control({
      type: 5,
      searchName: this.$route.query.keywords,
      pageNo: 1,
      pageSize: this.projectNum,
    }).then((res) => {
      this.projectCaseList = res.data.body.data;
    });
    },



    goBack() {
      this.$router.go(-1); // 返回上一个路由
    },
    //新闻详情
    toNews(id) {
      this.$router.push({
        name: "NewsDetail",
        query: {
          newsId: id,
        },
      });
    },
    // 贸易
    toTrade(id) {
      this.$router.push({
        name: "TradeDetail",
        query: {
          goodId: id,
        },
      });
    },
    // 沥拌
    toOperation(index) {
      this.$router.push({
        name: "OperationDetail",
        query: {
          id: index,
        },
      });
    },
    // 工程
    toProject(id) {
      this.$router.push({
        name: "projectCase",
        query: { id: id },
      });
    },
    //施工
    toBuild(id) {
      this.$router.push({
        name: "buildDetail",
        query: { id: id },
      });
    },
    moreNews() {
      this.newsNum+=6;
      this.getNews();
    },
    moreBuild(){
      this.buildNum+=6;
      this.getBuild()
    },
    moreTrade(){
      this.tradeNum+=6;
      this.getTrades();
    },
    moreOperation(){
      this.operationNum+=6;
      this.getOperation();
    },
    moreProject(){
      this.projectNum+=6;
      this.getProject()
    },

  },
};
</script>

<style scoped>
.head {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
  padding: 20px;
}
.big_title {
  font-size: 68px;
  font-weight: bold;
  color: #ffffff;
}

.hight_title {
  display: flex;
  justify-content: center;
  flex-direction: row;
}

.cn_title {
  position: absolute;
  font-size: 48px;
  font-weight: bold;
  color: #13489d;
  z-index: 2;
}

.en_title {
  position: absolute;
  font-size: 54px;
  font-weight: bold;
  color: #c8d4e1;
}

.return_button {
  width: 140px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #5877ba;
  font-size: 18px;
  font-weight: 400;
  color: #13489d;
  line-height: 48px;
  text-align: center;
  margin-left: 139px;
}

.return_button {
  cursor: pointer;
}
.body {
  width: 1200px;
  margin: auto;
  margin-top: 70px;
}
.content_row {
  display: flex;
  width: 100%;
  height: 2rem;
  margin: 10px 103px;
}

.content_title {
  width: 100%;
  height: 2rem;
  line-height: 2rem;
  font-size: 20px;
  font-weight: bold;
  color: #333333;
}

.colum {
  width: 0.7rem;
  height: 100%;
  margin-right: 20px;
  background-color: #13489d;
}
.content {
  display: flex;
  margin: auto;
  width: 62rem;
  height: 9rem;
  display: flex;
  /* background-color: rgb(247, 127, 127); */
  margin-bottom: 1rem;
  cursor: pointer;
}
.img_box {
  width: 15rem;
  height: 9rem;
}
.img_box img {
  width: 100%;
  height: 100%;
}
.right_content {
  margin-left: 2rem;
  width: 35rem;
}
.title {
  font-size: 1rem;
}
.des {
  margin-top: 1rem;
  font-size: 0.8rem;
  width: 37rem;
}
.more {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 7rem;
  height: 2.7rem;
  margin: auto;
  background-color: #13489d;
  color: #ffffff;
  margin-bottom: 2rem;
}
</style>
